import instance from '@/utils/instance';

//根据书单查询文件列表
export function getCorporateCatalogList(folderId, data) {
	return instance({
		url: `/webL_api/corporate/acc/corporateCatalog/${folderId}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'get',
	});
}

//查询书单文件列表--excel
export function getCorporateCatalogListExcel(folderId) {
	return instance({
		url: `/webL_api/corporate/acc/excelCorporateCatalog/${folderId}`,
		method: 'get',
	});
}

//添加文件到书单
export function postAddCorporateCatalog(data) {
	return instance({
		url: `/webL_api/corporate/acc/newCorporateCatalog`,
		method: 'post',
        data
	});
}

//移除书单内文件
export function postRemoveCorporateCatalog(data) {
	return instance({
		url: `/webL_api/corporate/acc/removeCorporateCatalog`,
		method: 'post',
		data
	});
}
